<template>
  <v-dialog
    :value="value"
    transition="dialog-top-transition" 
    max-width="30vw"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title class="text-h5">
        Поделиться дашбордом
      </v-card-title>

      <v-card-text>
        <p>Кому отправить?</p>
        <UserSelector v-model="agent" single label="Пользователь" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="warning"
          text
          @click="close"
        >
          Отмена
        </v-btn>

        <v-btn
          color="success"
          text
          @click="shareDashboard"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import UserSelector from '~/components/partials/selectors/UserSelector.vue';

export default {
  name: 'ShareDashboard',
  components: {
    UserSelector
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      agent: [],
    }
  },

  computed: {
    ...mapGetters({
      dashboard: 'dashboard/dashboard',
    }),

  },

  watch: {
  },

  methods: {
    ...mapActions({
      shareDashboards: 'dashboard/shareDashboards',
    }),
    
    close() {
      this.$emit('input', false);
    },

    shareDashboard() {
      let payload = {
        dashboard_id: this.dashboard.id,
        user_id: this.agent[0],
      }
      this.shareDashboards(payload);
      this.close();
    },
  },

  mounted() {

  }

}
</script>


<style scoped lang="scss">

</style>